// src/shared/components/common/brand-logo.tsx
// Логотип «ИИ-Менеджер»: цветной знак «ИИ» в облачке. Цвета зашиты (бренд),
// currentColor не наследуется.

interface BrandLogoProps {
  className?: string
}

export function BrandLogo({ className }: BrandLogoProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="24 23 1204 1204"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="626" cy="625" r="602" fill="#CB5E3F" />
      <path
        fill="#FBF7F1"
        d="M359 296H896A150 150 0 0 1 1046 446V747A150 150 0 0 1 896 897H478L281 1009Q263 1015 266 996L306 885Q209 845 209 747V446A150 150 0 0 1 359 296Z"
      />
      <path
        fill="#1C2B4A"
        d="M302 442H390V623L522 442H606V766H513V589L380 766H302ZM651 442H739V623L871 442H955V766H862V589L729 766H651Z"
      />
    </svg>
  )
}
